import { JSX } from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    required,
    NumberInput,
    useNotify,
    useRedirect,
    SelectArrayInput,
    BooleanInput,
    useCreate
} from 'react-admin';

export const PromptCreate: () => JSX.Element = (): JSX.Element => {
    return (
        <Create redirect="list">
            <SimpleForm>
                <TextInput name="name" source="name" validate={[required()]} fullWidth />
                <TextInput name="prompt" source="prompt" fullWidth validate={[required()]} multiline  rows={24}/>
            </SimpleForm>
        </Create>
    );
}